<template>
  <div>
    <input
      class="form-control search-input"
      type="text"
      v-model="filterText"
      placeholder="Hledej..."
    />
    <div class="table-responsive dbaccess-table">
      <table class="table">
        <thead>
          <tr>
            <th>#</th>
            <th>App</th>
            <th>Host</th>
            <th>dbName</th>
            <th>dbUser</th>
            <th>dbPassword</th>
            <th class="text-right">
              <i
                class="btn btn-success btn-sm fa fa-plus"
                @click="addRow = !addRow"
              ></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="addRow">
            <td></td>
            <td class="text-center">
              <input
                v-model="addFormAppKey"
                type="text"
                :class="{ 'is-invalid': formErrors['appKey'] }"
                class="form-control form-control-sm"
              />
            </td>

            <td class="text-center">
              <input
                v-model="addFormDbHost"
                type="text"
                class="form-control form-control-sm"
              />
            </td>

            <td class="text-center">
              <input
                v-model="addFormDbName"
                type="text"
                class="form-control form-control-sm"
              />
            </td>

            <td class="text-center">
              <input
                v-model="addFormDbUser"
                type="text"
                class="form-control form-control-sm"
              />
            </td>

            <td class="text-center">
              <input
                v-model="addFormDbPass"
                type="password"
                class="form-control form-control-sm"
              />
            </td>

            <td class="text-right">
              <i class="btn btn-success btn-sm fa fa-plus" @click="addItem"></i>
            </td>
          </tr>
          <application-item
            :key="application.id"
            :application="application"
            v-for="application in applications"
          ></application-item>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ApplicationItem from './ApplicationItem'
import { appValidation } from './validator'

export default {
  name: 'ApplicationList',
  data: function () {
    return {
      filterText: '',
      formErrors: [],
      addRow: false,
      addFormAppKey: '',
      addFormDbHost: '',
      addFormDbName: '',
      addFormDbUser: '',
      addFormDbPass: ''
    }
  },
  components: {
    ApplicationItem
  },
  computed: {
    applications: function () {
      const filtered = this.$store.getters.getApplications.filter((el) => {
        const search = el.appKey.toLowerCase();
        return search.match(this.filterText.toLowerCase());
      });
      return filtered;
    }
  },
  created: function () {
    this.$store.dispatch('fetchApplications');
  },
  methods: {
    async addItem () {
      const appData = {
        appKey: this.addFormAppKey,
        dbHost: this.addFormDbHost,
        dbName: this.addFormDbName,
        dbUser: this.addFormDbUser,
        dbPass: this.addFormDbPass
      };
      const formErrors = appValidation(appData);
      if (Object.keys(formErrors).length > 0) { // named indexes cannot use length
        this.formErrors = formErrors;
        return;
      }

      const success = await this.$store.dispatch('addApplication', appData);
      if (success) {
        this.addRow = false;
        this.addFormAppKey = '';
        this.addFormDbHost = '';
        this.addFormDbName = '';
        this.addFormDbUser = '';
        this.addFormDbPass = '';
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.search-input {
  margin-bottom: 20px;
}
.dbaccess-table {
  background-color: #ffffff;
  border-radius: 0.25rem;
}
</style>
